export default __webpack_public_path__ + "static/media/dashboard.29bafa5b.svg";